/*
 * Живий рядок дедлайну відправки в картці товару.
 *
 * Сторінка кешується CDN, тому час не можна рахувати в Liquid — на сервері
 * він застигне в момент рендеру. Серверний HTML містить варіант «до дедлайну»
 * (найчастіший стан удень), а цей елемент уточнює його в браузері за
 * годинником магазину, а не за годинником покупця.
 */
class DeliveryDeadline extends HTMLElement {
  connectedCallback() {
    this.output = this.querySelector('[data-dd-text]');
    if (!this.output) return;

    this.render();
    // Перемальовуємо на межі хвилини, щоб о 16:30 текст змінився сам,
    // без перезавантаження сторінки.
    this.timer = setInterval(() => this.render(), 60 * 1000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  /* Поточні година, хвилина й день тижня в часовому поясі магазину. */
  shopNow() {
    const tz = this.dataset.timezone || 'Europe/Kyiv';
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: tz,
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      weekday: 'short',
    }).formatToParts(new Date());

    const get = (type) => parts.find((part) => part.type === type)?.value || '';
    return {
      hour: parseInt(get('hour'), 10),
      minute: parseInt(get('minute'), 10),
      weekday: get('weekday'),
    };
  }

  render() {
    const now = this.shopNow();
    const isWeekend = now.weekday === 'Sat' || now.weekday === 'Sun';

    // Відправка є щодня, але у вихідні відсічення раніше.
    const cutoff = isWeekend
      ? this.dataset.cutoffWeekend || this.dataset.cutoff
      : this.dataset.cutoff;
    if (!cutoff) return;

    const [rawHour, rawMinute] = cutoff.split(':');
    const cutoffHour = parseInt(rawHour, 10);
    const cutoffMinute = parseInt(rawMinute || '0', 10);
    if (!Number.isFinite(cutoffHour)) return;

    const beforeCutoff =
      now.hour < cutoffHour || (now.hour === cutoffHour && now.minute < cutoffMinute);

    const text = beforeCutoff ? this.dataset.textBefore : this.dataset.textAfter;
    if (!text) return;

    this.output.textContent = text.replace('%s', cutoff);
  }
}

if (!customElements.get('delivery-deadline')) {
  customElements.define('delivery-deadline', DeliveryDeadline);
}
